<template>
  <div class="search-texts">
    <div
      class="container-fluid page-header"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/landing_page/buildings.jpg') + ')',
      }"
    >
      <div class="row">
        <div class="col-12">
          <div class="page-title">Banco de Dados</div>
          <div class="page-description">
            Preencha os campos abaixo para realizar pesquisas em nossa base de
            dados.
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-12">
          <div class="card">
            <div class="title-search">Pesquisar</div>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label for>Palavras-chave</label>
              </div>
              <input
                type="text"
                v-model="filter.description"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label class="info-search" @click="showHelp()"
                >Como a pesquisa funciona?</label
              >
            </div>
            <div class="form-group" v-if="show_help">
              <label
                >Para pesquisar por qualquer palavra, se mais de uma palavra,
                separar com um espaço / Ex: agravo regimental</label
              >
              <label
                >Para pesquisar por expressão, basta usar " no começo e no fim
                da expressão, se mais de uma, separar com um espaço / Ex:
                "agravo regimental" "negativa de seguimento"</label
              >
              <label
                >* É possível pesquisar por expressão e qualquer palavra / Ex:
                "agravo regimental" negativa seguimento</label
              >
              <label>
                ** Não utilizar palavras compostas por preposições se não utilizar a busca por expressão / Ex: negativa de seguimento
              </label>
            </div>
            <div class="form-group">
              <label for>Autor</label>
              <multiselect
                v-model="authors"
                :multiple="true"
                :options="createParams.authors"
                selectLabel
                deselectLabel
                selectedLabel
                track-by="id"
                label="name"
                placeholder="Todos os autores"
              ></multiselect>
            </div>
            <div class="form-group">
              <label for>Boletim</label>
              <multiselect
                v-model="magazines"
                :multiple="true"
                :options="createParams.magazines"
                selectLabel
                deselectLabel
                selectedLabel
                track-by="id"
                label="name"
                placeholder="Todos os boletins"
              ></multiselect>
            </div>
            <div class="form-group">
              <label for>Índice</label>
              <multiselect
                v-model="indices"
                :multiple="true"
                :options="createParams.indices"
                selectLabel
                deselectLabel
                selectedLabel
                track-by="id"
                label="name"
                placeholder="Todos os índices"
              ></multiselect>
            </div>
            <div class="form-group">
              <label for>Subíndice</label>
              <multiselect
                v-model="subindices"
                :multiple="true"
                :options="subindices_selected"
                selectLabel
                deselectLabel
                selectedLabel
                track-by="id"
                label="name"
                placeholder="Todos os subíndices"
                :showNoOptions="false"
              ></multiselect>
            </div>
            <div class="form-group">
              <label for>Período</label>
              <b-form-datepicker
                id="start-datepicker"
                v-model="filter.start_date"
                placeholder="De"
                class="mb-2"
              ></b-form-datepicker>
              <b-form-datepicker
                id="end-datepicker"
                v-model="filter.end_date"
                placeholder="Até"
                class="mb-2"
              ></b-form-datepicker>
            </div>
            <button
              class="btn btn-primary"
              style="height: 5vh"
              v-on:click="search()"
              :disabled="localLoading"
            >
              <b v-if="!localLoading">Pesquisar</b>
              <b-spinner
                type="grow"
                label="Spinning"
                v-if="localLoading"
              ></b-spinner>
            </button>
            <button
              class="btn btn-secondary"
              style="margin-top: 12px"
              v-on:click="clearFilter()"
            >
              Limpar Filtros
            </button>
          </div>
        </div>
        <div class="col-lg-7 col-12 results-col">
          <div class="card total-data">{{ rows }} Resultados</div>
          <div class="card news-card" v-for="item in data" v-bind:key="item.id">
            <router-link
              target="_blank"
              :to="{ name: 'client.read-text', query: { text_id: item.id } }"
            >
              <div class="header-card-news">{{ item.title }}</div>
              <div class="footer-card-news">
                {{
                  listAuthors(item.authors) +
                  formatDate(
                    item.publish_date ? item.publish_date : item.created_at
                  )
                }}
                <br />
                {{ listMagazines(item.magazines, item.magazine_editions) }}
              </div>
              <a target="_blank"></a>
            </router-link>
          </div>
          <b-pagination
            v-if="data.length > 0"
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Multiselect from "vue-multiselect";
import moment from "moment";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "search-texts",
  components: {
    Multiselect,
  },
  data() {
    return {
      filter: {
        description: "",
        start_date: null,
        end_date: null,
      },
      createParams: {
        magazines: [],
        indices: [],
        authors: [],
      },
      magazines: [],
      indices: [],
      subindices: [],
      subindices_selected: [],
      authors: [],
      perPage: 5,
      currentPage: 1,
      rows: 0,
      data: [],
      localLoading: false,
      show_help: false,
    };
  },
  watch: {
    indices: {
      handler: function (value) {
        this.mountSubIndices();
      },
    },
    currentPage: {
      handler: function (value) {
        this.providerData();
      },
    },
  },
  mounted() {
    this.getCreateParams();
    this.getSavedData();
  },
  methods: {
    sortAuthors: function () {
      this.createParams.authors.sort(function (a, b) {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    getCreateParams: function () {
      bus.$emit("changeLoading", true);
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/texts_public/create`)
        .then((data) => {
          this.createParams = data.data;
          bus.$emit("changeLoading", false);
          this.sortAuthors();
        });
    },
    mountSubIndices: function () {
      this.subindices_selected = [];
      this.indices.forEach((el) => {
        el.sub_indices.forEach((subEl) => {
          this.subindices_selected.push(subEl);
        });
      });
    },
    search() {
      this.currentPage = 1;
      this.providerData();
    },
    clearFilter() {
      this.filter = {
        description: "",
        start_date: null,
        end_date: null,
        type_filter: "filter_content",
      };
      this.magazines = [];
      this.indices = [];
      this.subindices = [];
      this.subindices_selected = [];
    },
    providerData() {
      // bus.$emit("changeLoading", true);
      this.localLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/texts_public?${this.urlBuild()}`
        )
        .then((response) => {
          this.rows = response.data.total;
          this.data = response.data.data;
          bus.$emit("changeLoading", false);
          this.localLoading = false;
        })
        .catch((error) => {
          bus.$emit("changeLoading", false);
          this.localLoading = false;
          Swal.fire({
            title: "Ocorreu um erro.",
            text: "Verifique a sintaxe da pesquisa",
            icon: "error",
          });
        });
    },
    getSavedData: function () {
      if (localStorage.getItem("filters_search") != "") {
        var data = JSON.parse(localStorage.getItem("filters_search"));
        this.filter = data.filter;
        this.magazines = data.magazines;
        this.indices = data.indices;
        this.authors = data.authors;
        this.subindices = data.subindices;
      }
    },
    saveDataOnStorage: function () {
      let filters = {
        filter: this.filter,
        magazines: this.magazines,
        indices: this.indices,
        authors: this.authors,
        subindices: this.subindices,
      };
      localStorage.setItem("filters_search", JSON.stringify(filters));
    },
    urlBuild: function () {
      this.saveDataOnStorage();
      let url =
        "sort=-id&include=authors,magazines,magazineEditions&page[number]=" +
        this.currentPage +
        "&page[size]=" +
        this.perPage +
        (this.filter.description != ""
          ? `&filter[filter_content]=${this.filter.description
              .split("+")
              .join(":")}`
          : "") +
        (this.magazines.length > 0
          ? `&filter[magazines.id]=${this.generateFilterArray(this.magazines)}`
          : "") +
        (this.indices.length > 0
          ? `&filter[indice_id]=${this.generateFilterArray(this.indices)}`
          : "") +
        (this.authors.length > 0
          ? `&filter[authors.id]=${this.generateFilterArray(this.authors)}`
          : "") +
        (this.subindices.length != 0
          ? `&filter[sub_indice_id]=${this.generateFilterArray(
              this.subindices
            )}`
          : "") +
        (this.filter.start_date
          ? `&filter[published_after]=${this.filter.start_date}`
          : "") +
        (this.filter.end_date
          ? `&filter[published_before]=${this.filter.end_date}`
          : "");

      return url;
    },
    generateFilterArray: function (array) {
      let filter = "";
      array.forEach((el, index) => {
        filter += el.id + (index < array.length - 1 ? "," : "");
      });
      return filter;
    },
    formatDate: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
    listAuthors: function (array) {
      let str = "";
      if (array) {
        array.forEach((el, index) => {
          str += el.name + (index < array.length - 1 ? ", " : " – ");
        });
      }
      return str;
    },
    formatDateNumberToName: function (date) {
      return moment(date).lang("pt-br").format("MMMM YYYY");
    },
    listMagazines: function (array, edition) {
      let str = "";
      if (array) {
        array.forEach((el, index) => {
          edition.forEach((elu, index2) => {
            if (el.id == elu.magazine_id) {
              str +=
                el.name +
                (index < array.length - 1 ? "" : " – ") +
                (elu.created_at
                  ? moment(elu.created_at).lang("pt-br").format("MMMM YYYY")
                  : "") +
                " " +
                "nº" +
                (elu.edition_number != null ? elu.edition_number : "");

              if (index < array.length - 1) {
                str += ", ";
              }
            }
          });
        });
      }
      return str;
    },
    showHelp: function () {
      this.show_help = !this.show_help;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
.search-texts {
  .info-icon {
    color: $red_primary;
    font-size: 20px;
  }
  .info-icon:hover {
    color: $red_primary_hover;
    cursor: pointer;
  }
  .info-icon:focus {
    outline: none;
  }
  .title-search {
    font-size: 20px;
    color: $red_primary;
    font-weight: bold;
    margin-bottom: 16px;
  }
  .total-data {
    font-size: 18px;
    font-weight: bold;
    padding: 0.5vw 1vw;
  }
  .news-card {
    padding: 0.8vw 1vw 1.8vw 1vw;
    min-height: 110px;
    position: relative;
    .header-card-news {
      font-weight: bold;
      margin-bottom: 10px;
    }
    .footer-card-news {
      // position: absolute;
      bottom: 0.8vw;
      margin-top: 8px;
      font-size: 12px;
      color: #5f6064;
    }
    a {
      text-decoration: none;
      color: #5f6064;
    }
    a:hover {
      color: black;
    }
  }
  .results-col {
    position: relative;
    .float-right {
      position: absolute;
      bottom: 0;
      right: 15px;
    }
  }
  .info-content {
    height: 75vh;
    overflow-y: auto;
  }
  .info-search {
    color: $red_primary;
    cursor: pointer;
  }
  .info-search:hover {
    text-decoration: underline;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>